var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Readme")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","xs":"12"}},[_c('v-card',{attrs:{"width":"100%"}},[_c('v-card-text',[_c('mdfile')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }